module.exports = require('../dist/components/Accent/Accent');
